export default "__VITE_ASSET__c4f0667d__"